import React from 'react';
import { useDispatch } from 'react-redux';
import SharedRefreshButton from 'shared/ui/RefreshButton';
import { getData } from 'Screens/Contextualization/Workspaces/actions/Actions';

// eslint-disable-next-line import/prefer-default-export
export const RefreshButton = () => {
  const dispatch = useDispatch();

  const handleClick = () => (dispatch(getData()));

  return (
    <SharedRefreshButton onClick={ handleClick } />
  );
};
